import { render, staticRenderFns } from "./CloudpolicyList.vue?vue&type=template&id=084b520c&"
import script from "./CloudpolicyList.vue?vue&type=script&lang=js&"
export * from "./CloudpolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports